import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@material-ui/core'
import Icon from '../../atoms/Icon'
import { KEYS } from '../../../constants'

const ICON_SIZES = {
  xs: 14,
  sm: 18,
  lg: 22
}

function InlineSearchInput ({ iconName, defaultValue, onChange }) {
  const inputRef = useRef(null)
  const [value, setValue] = useState(defaultValue ?? '')
  const handleChange = useCallback((e) => {
    setValue && setValue(e.target.value)
    onChange(e.target.value)
  }, [setValue, onChange])

  const handleClear = useCallback(() => {
    setValue('')
    onChange('')
  }, [setValue, onChange])

  useEffect(() => {
    const handler = (e) => {
      if (inputRef.current.value && e.which === KEYS.ESC) {
        handleClear()
        e.stopPropagation()
        e.preventDefault()
      }
    }
    window.addEventListener('keydown', handler, true)
    return () => {
      window.removeEventListener('keydown', handler, true)
    }
  }, [handleClear])

  return (
    <div className='flex items-center gap-xs p-sm border-neutral-500 bg-neutral-100' style={{ minHeight: '44px' }}>
      <Icon name={iconName} customSize={ICON_SIZES.sm} />
      <input
        className='bg-neutral-100'
        style={{ border: 'none', outline: 'none', flex: '1 0', height: '100%' }}
        autoFocus
        ref={inputRef}
        value={value}
        onChange={handleChange}
      />
      {value ? (
        <IconButton size='small' onClick={handleClear}>
          <Icon name='close' customSize={ICON_SIZES.sm} />
        </IconButton>
      ) : null}
    </div>
  )
}

InlineSearchInput.propTypes = {
  iconName: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func
}

InlineSearchInput.defaultProps = {
  iconName: 'search',
  defaultValue: '',
  onChange: () => {}
}

export default InlineSearchInput
